let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jzecC")).then(() => parcelRequire('6pwND'));